export function togglePlugin(key, args) {
    // Sichtbarkeit von Plugins (Teildaten) je Vertragsart ermitteln

    // Mögliche Argumente, die in den regeln vorkommen können
  const { istWerkvertrag,
          istLehrauftrag,
          istTarif,
          istWiss,
          istWHK } = args;

    // Regeln für die Sichtbarkeit je Plugin / Bereich
  const visibleRules = {
    arbeitszeit: () => !istWerkvertrag && !istLehrauftrag,
    tätigkeit: () => !istWerkvertrag && !istLehrauftrag && !istTarif,
    qualiziele: () => istWHK || (istTarif && istWiss),
    deputat: () => istTarif,
  };

  const rule = visibleRules[key];
  if (rule) {
        // Regel gefunden, anwenden
    return rule(args);
  }
        // Keine Regel gefunden: Plugin immer anzeigen
  return true;
}
